export default "__VITE_ASSET__DOO0Olrc__"